import $$ from "../utils/double-dollar";
import "toastr";
import axios, { AxiosError, AxiosResponse } from "axios";
import Multilang from "../utils/multilang";
import MiniQuote from "../components/mini-quote";

type AddToQuoteRequest = {
  quantity: number;
  productId: number;
  orderUnitId: number;
};

class ChangeQuoteName {
  private readonly input: HTMLInputElement;

  constructor(element: Element) {
    this.input = element as HTMLInputElement;
    this.input.addEventListener("change", this.handleChange.bind(this));
    this.input.addEventListener("keypress", this.handleKeyPress.bind(this));
  }

  private handleChange(event: Event) {
    console.log("handle change");
    this.submit();
  }

  private handleKeyPress(event: KeyboardEvent) {
    if (event.key === "Enter") {
      event.preventDefault();
      event.stopImmediatePropagation();
      this.submit();
    }
  }

  private submit() {
    this.input.classList.remove("is-valid");
    this.input.classList.remove("is-invalid");

    const form = this.input.closest("form");
    const url = form?.action;

    if (!url) {
      return;
    }

    fetch(form?.action, {
      method: "POST",
      body: new FormData(form as HTMLFormElement)
    })
      .then((response) => {
        if (!response.ok) {
          console.error(response.text());
        }

        this.setClasses(response.ok);
      })
      .catch((error) => {
        console.error(error);
        this.setClasses(false);
      });
  }

  private setClasses(isValid: boolean) {
    if (!isValid) {
      this.input.classList.add("is-invalid");
    }
    else {
      this.input.classList.add("is-valid");
    }

    const submitForm = document.getElementById("form-basket-step-1");
    const submitBtn = submitForm?.querySelector("[type=submit]") as HTMLButtonElement;

    if (submitBtn) {
      submitBtn.disabled = !isValid;
    }
  }
}

class AddToQuote {
  constructor(private element: Element) {
    this.element.addEventListener("click", this.handleClick);
  }

  private handleClick(event: Event) {
    const button = event.currentTarget as HTMLButtonElement;
    const form = button.form;
    if (!form) {
      console.error("No form found for button", button);
      return;
    }

    const quantity = (form.elements.namedItem("quantity") as HTMLInputElement)?.value;
    const productId = (form.elements.namedItem("productid") as HTMLInputElement)?.value;
    const orderUnitId = (form.elements.namedItem("orderunitid") as HTMLSelectElement)?.value;

    console.log("Quantity", quantity);
    console.log("ProductId", productId);
    console.log("OrderUnitId", orderUnitId);

    const body = {
      quantity,
      productId,
      orderUnitId
    };

    axios
      .post("/api/quote/add", body)
      .then((response: AxiosResponse) => response.data)
      .then(data => {
        if (!data) {
          return;
        }

        toastr["success"](data);

        MiniQuote.load();

      })
      .catch((error: AxiosError) => {
        console.error(error);

        if (error.response?.status === 403) {
          toastr["warning"](error.response?.statusText);
        }

        if (error.response?.status === 404 || error.response?.status === 500) {
          const labelName = "AddToQuote.message.exception";
          const defaultValue = "Er trad een fout op bij het toevoegen aan de prijsaanvraag.";
          const msg = Multilang.getTranslation(labelName, defaultValue);
          toastr["error"](msg);
        }
      });
  }
}

export default class Quote {
  static init() {
    $$("button.js-add-to-quote", el => new AddToQuote(el));
    $$("input.js-change-quote-name", el => new ChangeQuoteName(el));
  }
}
